import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "/post-types";

const contentTypeApi = {
  contents(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getContent(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  postContent(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putContent(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  deleteContent(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default contentTypeApi;
